import { useCallback, useState } from "react";

const read = (key, fallback) => {
  try {
    const raw = window.localStorage.getItem(key);
    return raw === null ? fallback : raw === "true";
  } catch {
    return fallback;
  }
};

/**
 * Booleano que lembra o último valor no navegador (localStorage), ex:
 * menu lateral recolhido, seção aberta/fechada. Se o storage não estiver
 * disponível, funciona normalmente só em memória.
 */
export default function usePersistentToggle(key, initialValue = false) {
  const [value, setState] = useState(() => read(key, initialValue));

  const setValue = useCallback(
    (next) => {
      setState((prev) => {
        const resolved = typeof next === "function" ? next(prev) : next;
        try {
          window.localStorage.setItem(key, String(resolved));
        } catch {
          /* storage bloqueado — segue só em memória */
        }
        return resolved;
      });
    },
    [key],
  );

  const toggle = useCallback(() => setValue((prev) => !prev), [setValue]);

  return { value, setValue, toggle };
}
